import React from 'react';
import { Building2, Phone, Mail } from 'lucide-react';

export function AboutContact() {
  return (
    <div className="mt-16 bg-accessible-red-600 rounded-lg p-8 text-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="heading-2-white mb-4">
            Skontaktuj się z nami
          </h2>
          <p className="body-medium-white">
            Jesteśmy tutaj, aby odpowiedzieć na Twoje pytania
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/10 p-6 rounded-lg">
            <div className="flex items-center gap-3 mb-4">
              <Building2 className="w-6 h-6 text-white" aria-hidden="true" />
              <h3 className="label-large-white">Adres</h3>
            </div>
            <p className="body-medium-white-90">
              Krusze ul. Kryształowa 171<br />
              05-240 Tłuszcz
            </p>
          </div>
          
          <div className="bg-white/10 p-6 rounded-lg">
            <div className="flex items-center gap-3 mb-4">
              <Phone className="w-6 h-6 text-white" aria-hidden="true" />
              <h3 className="label-large-white">Telefon</h3>
            </div>
            <a href="tel:+48664821160" className="link-white">
              664 821 160
            </a>
          </div>
          
          <div className="bg-white/10 p-6 rounded-lg">
            <div className="flex items-center gap-3 mb-4">
              <Mail className="w-6 h-6 text-white" aria-hidden="true" />
              <h3 className="label-large-white">Email</h3>
            </div>
            <a href="mailto:znajdki2012@gmail.com" className="link-white">
              znajdki2012@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}